import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { Card, CardText, Menu, MenuItem, Popover, Dialog, IconButton, FlatButton } from 'material-ui';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import { grey600 } from 'material-ui/styles/colors';
import _ from 'lodash';
import { LANGUAGES, STORE_KEYS } from 'dash-front/constants';
import { TextRow } from 'react-placeholder/lib/placeholders';
import { LOADING_CLASSNAME, LOADING_COLOR } from 'dash-front/constants';
import { getEntities } from 'dash-front/selectors';
import { deleteCampaign } from 'dash-front/campaign/actions/campaigns';
import { SMLinkTitle } from 'dash-front/campaign/containers/SMLink';

const LANG_MAP = LANGUAGES.reduce((acc, cur) => {
    acc[cur.key] = cur.name;
    return acc;
}, {});

const ROW_WIDTH = 300;
const rowFn = loaded => (left, right) => (
    <div style={{ display: 'inline', marginTop: 4, marginBottom: 4 }}>
        <div
            style={{
                width: ROW_WIDTH / 2,
                color: grey600,
                display: 'inline-block',
                verticalAlign: 'top'
            }}
        >
            {typeof left === 'string' ? <b>{left}</b> : left}
        </div>
        <div style={{ display: 'inline-block', width: ROW_WIDTH / 2 }}>
            {loaded ? (
                right
            ) : (
                <TextRow
                    className={LOADING_CLASSNAME}
                    color={LOADING_COLOR}
                    style={{ width: '90%', height: 13, margin: 0 }}
                />
            )}
        </div>
    </div>
);

class Actions extends React.PureComponent {
    state = {
        deleteOpen: false
    };
    handleTouchTap = event => {
        event.preventDefault();
        this.setState({
            open: true,
            anchorEl: event.currentTarget
        });
    };
    handleRequestClose = () => {
        this.setState({
            open: false
        });
    };

    onCloseDeleteDialog = () => {
        this.setState({ deleteOpen: false });
    };

    onOpenDeleteDialog = () => {
        this.setState({ deleteOpen: true });
        this.handleRequestClose();
    };

    onDelete = () => {
        this.props.onDelete();
        this.onCloseDeleteDialog();
    };

    render() {
        const { campaignId } = this.props;
        return (
            <div>
                <IconButton onTouchTap={this.handleTouchTap}>
                    <MoreVertIcon />
                </IconButton>
                <Dialog
                    title={'Deletion'}
                    actions={[
                        <FlatButton primary label={'Cancel'} onClick={this.onCloseDeleteDialog} />,
                        <FlatButton secondary keyboardFocused label={'Yes, delete'} onClick={this.onDelete} />
                    ]}
                    modal={false}
                    open={this.state.deleteOpen}
                    onRequestClose={this.onCloseDeleteDialog}
                >
                    Are you sure you want to delete the campaign?
                </Dialog>
                <Popover
                    open={this.state.open}
                    anchorEl={this.state.anchorEl}
                    anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
                    targetOrigin={{ horizontal: 'left', vertical: 'top' }}
                    onRequestClose={this.handleRequestClose}
                >
                    <Menu>
                        <MenuItem
                            style={{ color: '#ff4081' }}
                            primaryText="Delete"
                            onTouchTap={this.onOpenDeleteDialog}
                        />
                        <MenuItem
                            primaryText="Edit"
                            onTouchTap={() => browserHistory.push(`/campaigns/edit/${campaignId}`)}
                        />
                        <MenuItem
                            primaryText="Manual post"
                            onTouchTap={() => browserHistory.push(`/campaigns/manual-post/${campaignId}`)}
                        />
                    </Menu>
                </Popover>
            </div>
        );
    }
}

Actions.propTypes = {
    campaignId: PropTypes.string.isRequired,
    onDelete: PropTypes.func.isRequired
};

const CampaignInfo = ({ campaign, deleteCampaign }) => {
    const {
        _id,
        title,
        active,
        moderation,
        language,
        messengerNotifications = [],
        notificationsTo = [],
        targets = []
    } =
        campaign || {};
    const notifications = Array.isArray(notificationsTo) ? notificationsTo : [];
    const targetsAr = Array.isArray(targets) ? targets : [];
    const getRow = rowFn(Boolean(campaign));
    return (
        <Card>
            <CardText>
                <div style={{ position: 'relative' }}>
                    {_id ? (
                        <div style={{ position: 'absolute', top: 0, right: 0 }}>
                            <Actions campaignId={_id} onDelete={deleteCampaign} />
                        </div>
                    ) : null}
                </div>
                <div style={{ display: 'flex', padding: 16 }}>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            width: ROW_WIDTH
                        }}
                    >
                        {getRow('Name:', title)}
                        {getRow('Status:', active ? 'Active' : 'Not active')}
                        {getRow('Language:', LANG_MAP[language] || 'N/A')}
                        {getRow('Moderation:', moderation ? 'On' : 'Off/Auto')}
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            width: ROW_WIDTH
                        }}
                    >
                        {getRow(
                            'Callbacks:',
                            notifications.length
                                ? notifications.map((el, index) => (
                                      <span style={{ display: 'inline-block' }} key={index}>
                                          {el.value}
                                      </span>
                                  ))
                                : '-'
                        )}
                        {getRow(
                            'FB Messenger:',
                            messengerNotifications.length
                                ? messengerNotifications.map((el, index) => (
                                      <span key={index}>
                                          {el.userName && (
                                              <span>
                                                  <span
                                                      style={{
                                                          display: 'inline-block',
                                                          verticalAlign: 'middle'
                                                      }}
                                                  >
                                                      {el.userName}
                                                  </span>

                                                  {el.userPhoto && (
                                                      <img
                                                          style={{
                                                              width: '30px',
                                                              height: '30px',
                                                              marginLeft: '10px',
                                                              borderRadius: '50%',
                                                              display: 'inline-block',
                                                              verticalAlign: 'middle'
                                                          }}
                                                          src={el.userPhoto}
                                                          alt="_"
                                                      />
                                                  )}
                                              </span>
                                          )}
                                          {!el.userName && (
                                              <span
                                                  style={{
                                                      wordBreak: 'break-all',
                                                      paddingLeft: '10px',
                                                      textAlign: 'right',
                                                      display: 'inline-block'
                                                  }}
                                              >
                                                  {el.value}
                                              </span>
                                          )}
                                      </span>
                                  ))
                                : '-'
                        )}
                        {getRow(
                            'Targets:',
                            targetsAr.map(el => (
                                <div key={el.value}>
                                    <SMLinkTitle id={el.value} />
                                </div>
                            ))
                        )}
                    </div>
                </div>
            </CardText>
        </Card>
    );
};

export default connect(
    (state, { campaignId }) => ({ campaign: _.get(getEntities(state)[STORE_KEYS.CAMPAIGNS], campaignId) }),
    (dispatch, { campaignId }) => ({
        deleteCampaign: () => dispatch(deleteCampaign(campaignId)).then(() => browserHistory.push('/campaigns'))
    })
)(CampaignInfo);



/** WEBPACK FOOTER **
 ** ../src/dash/front/campaign/components/List/CampaignInfo.js
 **/